import '../styles/booking.css';
import { useTranslation } from '../../i18n/useTranslation';
import { LanguageSwitcher } from '../components/LanguageSwitcher.js';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="booking-container" style={{ textAlign: 'center' }}>
      <div className="booking-card">
        <div className="booking-card-lang-row">
          <LanguageSwitcher />
        </div>
        <p className="booking-404-code">404</p>
        <h1 className="booking-title">{t('booking.notFoundTitle')}</h1>
      </div>
    </div>
  );
}
